// import { env } from './.env';

export const environment = {
  production: true,
  // version: env.npm_package_version,
  serverUrl: 'https://audit-wuff-production-3ncuuzlm4a-uc.a.run.app',
  appName: 'audit-wuff'
};
